var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.828,
    viewBox: "0 0 14 14.828"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-right{opacity:0.8;}.arrow-right_b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-right",
    transform: "translate(-4 -3.586)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "arrow-right_b",
    x2: 12,
    transform: "translate(5 11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arrow-right_b",
    d: "M12,5l6,6-6,6",
    transform: "translate(-1)"
  }))));
};
export default SvgArrowRight;